import { useSelector } from "react-redux";
import { FORM_STATUSES } from "../../../util/constants";
import { selectCurrentFormDataStatus, selectActionsToAllow } from "../../../services/form/slices";
import { useParams } from "react-router-dom";

function useFormConditionals () {
  const { id, type: formType } = useParams();
  const allowSavingWithoutValidation = useSelector((state) => {
    if (!id) {
      return true;
    }
    const status = selectCurrentFormDataStatus(state, formType, id);
    if (status === FORM_STATUSES.DRAFT) {
      return true;
    }
    return false;
  });

  const showAcceptButton = useSelector(
    (state) =>
      selectActionsToAllow(state, {
        id,
        formType,
      })?.showAcceptButton
  );
  
  return {
    allowSavingWithoutValidation,
    showAcceptButton
  };
}

export default useFormConditionals;
